import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { IonicModule } from '@ionic/angular';

@Component({
    selector: 'app-boton-volver',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './boton-volver.component.html',
    styleUrls: ['./boton-volver.component.scss'],
    standalone: true,
    imports: [CommonModule, IonicModule]
})
export class BotonVolverComponent {
    @Input() texto: string = 'Volver';
    @Input() nombreIcono: string = 'arrow-back-outline';
    @Output() clickVolver: EventEmitter<void> = new EventEmitter<void>();

    alHacerClicVolver(): void {
        this.clickVolver.emit();
    }
}
